module.exports = __webpack_public_path__ + "fonts/Univers-LT-Std-57-Condensed.580a3d5.otf";